import script from "./IPlayarrModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IPlayarrModal.vue?vue&type=script&setup=true&lang=js"

import "./IPlayarrModal.vue?vue&type=style&index=0&id=454117c2&lang=less"

const __exports__ = script;

export default __exports__